import { AbstractControl, ValidationErrors } from '@angular/forms';

const isSolarStorageSelected = (control: AbstractControl): boolean => {
  const equipmentControl = control.parent;
  const rootEquipmentControl = control.root?.get('equipment_information');
  const energySources =
    equipmentControl?.get('energy_source')?.value ??
    rootEquipmentControl?.get('energy_source')?.value ??
    control.root?.value?.equipment_information?.energy_source;

  return (
    Array.isArray(energySources) &&
    energySources.includes('Solar') &&
    energySources.includes('Storage')
  );
};

const requiresEquipment = (
  control: AbstractControl,
  errorKey: string
): ValidationErrors | null => {
  const hasEquipment = Array.isArray(control.value) && control.value.length > 0;

  return isSolarStorageSelected(control) && !hasEquipment
    ? { [errorKey]: true }
    : null;
};

export function solarStorageInverterValidator(
  control: AbstractControl
): ValidationErrors | null {
  return requiresEquipment(control, 'invalidSolarStorageInverter');
}

export function solarStorageBatteryValidator(
  control: AbstractControl
): ValidationErrors | null {
  return requiresEquipment(control, 'invalidSolarStorageBattery');
}
